import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
  head: () => ({
    meta: [
      { title: "Política de Privacidad — Watts" },
      { name: "description", content: "Política de Privacidad de la plataforma Watts." },
    ],
  }),
});

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-[#f5f5f5]">
      <div className="mx-auto max-w-2xl px-6 py-8 pb-[max(env(safe-area-inset-bottom),2rem)]">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Link
            to="/auth"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#1a1a1a] text-[#f5f5f5] hover:bg-[#2a2a2a] transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Política de Privacidad</h1>
            <p className="text-sm text-[#888]">Watts — wattsapp.es</p>
          </div>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-[#ccc]">
          <div className="rounded-xl bg-[#1a1a1a] p-4 text-xs text-[#888]">
            <p><span className="text-[#f5f5f5] font-medium">Titular:</span> PROAISTUDIO SCP</p>
            <p><span className="text-[#f5f5f5] font-medium">Contacto:</span> proaistudio2@gmail.com</p>
            <p><span className="text-[#f5f5f5] font-medium">Última actualización:</span> 21 de mayo de 2026</p>
          </div>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">1. Responsable del tratamiento</h2>
            <p>PROAISTUDIO SCP es responsable del tratamiento de los datos personales del usuario.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">2. Datos que recopilamos</h2>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Email</li>
              <li>Nombre de usuario</li>
              <li>Contraseña cifrada</li>
              <li>Preferencias de uso</li>
              <li>Rutas y actividad dentro de la app</li>
              <li>IP y datos técnicos del dispositivo</li>
              <li>Geolocalización (solo con consentimiento)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">3. Finalidad</h2>
            <p>Usamos los datos para:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Crear y gestionar cuentas</li>
              <li>Prestar el servicio</li>
              <li>Mostrar rutas cercanas (si se activa ubicación)</li>
              <li>Mejorar la plataforma</li>
              <li>Garantizar seguridad</li>
              <li>Cumplir obligaciones legales</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">4. Base legal</h2>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Ejecución del servicio</li>
              <li>Consentimiento del usuario</li>
              <li>Interés legítimo en seguridad</li>
              <li>Obligación legal</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">5. Conservación</h2>
            <p>Los datos se mantienen mientras la cuenta esté activa.</p>
            <p className="mt-2">Tras eliminación:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Borrado o anonimización en máximo 30 días</li>
              <li>Salvo obligación legal</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">6. Derechos del usuario</h2>
            <p>El usuario puede ejercer:</p>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Acceso</li>
              <li>Rectificación</li>
              <li>Supresión</li>
              <li>Oposición</li>
              <li>Portabilidad</li>
              <li>Limitación</li>
              <li>Retirada de consentimiento</li>
            </ul>
            <p className="mt-2">Contacto: proaistudio2@gmail.com</p>
            <p className="mt-1">Reclamación ante AEPD: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#F5C518] underline">www.aepd.es</a></p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">7. Comunicaciones</h2>
            <ul className="mt-2 ml-4 list-disc space-y-1 text-[#bbb]">
              <li>Operativas: necesarias para el servicio</li>
              <li>Comerciales: solo con consentimiento</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">8. Geolocalización</h2>
            <p>Es opcional y requiere consentimiento explícito.</p>
            <p className="mt-2">Puede desactivarse en cualquier momento.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">9. Seguridad</h2>
            <p>Aplicamos medidas técnicas para proteger los datos.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">10. Transferencias</h2>
            <p>Solo dentro del EEE o con garantías RGPD.</p>
          </section>

          <section>
            <h2 className="font-display text-lg font-semibold text-[#f5f5f5] mb-2">11. Cambios</h2>
            <p>Podemos actualizar esta política cuando sea necesario.</p>
          </section>
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/auth"
            className="inline-flex items-center gap-2 rounded-full bg-[#F5C518] px-6 py-2.5 text-sm font-bold text-black hover:bg-[#e6b800] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al registro
          </Link>
        </div>
      </div>
    </div>
  );
}
